import { useCallback, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { resolveRange } from '../components/filters/dateRanges';

/**
 * A page's filters, kept in the URL so reloads, links and the back button keep them. defaults must be a constant
 * object. setQuery: changes of null, '' or the default drop the parameter; any change but page goes back to page 1.
 */
export default function useUrlQuery(defaults) {
  const [searchParams, setSearchParams] = useSearchParams();
  const key = searchParams.toString();
  const query = useMemo(() => ({ ...defaults, ...Object.fromEntries(new URLSearchParams(key)) }), [key, defaults]);

  const setQuery = useCallback((changes) => {
    setSearchParams((previous) => {
      const next = new URLSearchParams(previous);
      Object.entries(changes).forEach(([name, value]) => {
        if (value == null || value === '' || value === defaults[name]) next.delete(name);
        else next.set(name, String(value));
      });
      if (!('page' in changes)) next.delete('page');
      return next;
    }, { replace: true });
  }, [setSearchParams, defaults]);

  return [query, setQuery];
}

// The ads API's scope filters (site, parents, date range) of a URL query, without empty values
export function scopeParams(query) {
  const { since, until } = resolveRange(query);
  return compact({
    site: query.site, ad_account: query.ad_account, campaign: query.campaign, adset: query.adset, since, until,
  });
}

export function compact(params) {
  return Object.fromEntries(Object.entries(params).filter(([, value]) => value != null && value !== ''));
}
